var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWhitePlus = function SvgWhitePlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.2 0c-.597 0-1.08.484-1.08 1.081V8.92H1.28a1.081 1.081 0 1 0 0 2.162H9.12v7.838a1.081 1.081 0 1 0 2.162 0V11.08h7.838a1.081 1.081 0 1 0 0-2.162h-7.838V1.081c0-.597-.484-1.081-1.08-1.081Z"
  })));
};
export default SvgWhitePlus;